import ShareWidgetSVG from 'www/svg-icons/share-widget';
import { distinctUntilChanged } from 'rxjs/operators';
import { PromosShareLayer } from './promos-share-layer';
import { TooltipWidget } from 'www/modules/tooltip/tooltip-widget';
import { ViewportSizeChange } from 'www/observables/viewport-size-change';
export class PromosShareWidget extends TooltipWidget{
    constructor() {
        super();
        this._el = null;
        this._labelContainer = null;
        this._iconContainer = null;
        this._TooltipLayer = PromosShareLayer;
    }
    init(){
        super.init();
        this.el.classList.add('medscape-share-widget');
        this.linkEl.insertAdjacentElement("afterbegin",this.iconContainer);
        this.linkEl.insertAdjacentElement("beforeend",this.labelContainer);
        ViewportSizeChange.pipe(
            distinctUntilChanged(null,data=>{
                return data.breakpoint;
            })
        )
        .subscribe(data=>{
            this.handleViewportSizeChange(data);
        })
        
    }
    get TooltipLayer(){
        return this._TooltipLayer;
    }
    set TooltipLayer(TooltipLayer=PromosShareLayer){
        this._TooltipLayer = TooltipLayer;
    }
    get breakpoint(){
        return window.breakpoint;
    }

    get labelText() {
    	
        const locale = window.locale || 'en';
        
        let labelText = ""; 
        
        if (locale === 'de') {
        	labelText = 'Teilen';
        } else if (locale === 'fr') {
        	labelText = "Partager";
        } else if (locale === 'es') {
        	labelText = "Compartir";
        } else if (locale === 'pt') {
        	labelText = "Compartilhar";
        } else {
        	labelText = this.breakpoint>1 ? "Share This" : "Share";
        }
        
        return `${labelText.toUpperCase()}`;
    }
    get labelContainer() {
        if (this._labelContainer == null) {
            let labelContainer = document.createElement('span');
            labelContainer.classList.add('label-container');
            labelContainer.innerHTML = this.labelText;
            this._labelContainer = labelContainer;
        }
        return this._labelContainer;
    }
    get iconContainer() {
        if (this._iconContainer == null) {
            let iconContainer = document.createElement('span');
            iconContainer.classList.add('icon-container');
            iconContainer.appendChild(ShareWidgetSVG.useSprite);
            this._iconContainer = iconContainer;
        }
        return this._iconContainer;
    }

    handleViewportSizeChange(data){
        this.labelContainer.innerHTML = this.labelText;
    }


}
